<!-- Navigation Bar-->
<header id="topnav">
  <div class="topbar-main">
    <div class="container">
      <!-- Logo container-->
      <div class="logo">
        <!-- <a [routerLink]="['/reshome']" class="logo"> -->
        <a class="logo" [title]="isFarronResearch ? 'Farron Research Logo' : 'Logo'">
          <span class="hidden-xs">
            <img src="assets/images/fr-logo.png" [alt]="isFarronResearch ? 'Farron Research Logo' : 'Logo'">
          </span>
          <span class="hidden-sm hidden-md hidden-lg">
            <img src="assets/images/fr-only-logo.png" [alt]="isFarronResearch ? 'Farron Research Logo' : 'Logo'">
          </span>
        </a>
      </div>
      <!-- End Logo container-->
      <div class="menu-extras">
        <ul class="nav navbar-nav navbar-right pull-right">
          <li class="dropdown hidden">
            <a data-target="#" class="dropdown-toggle waves-effect waves-light" data-backdrop="static"
              data-toggle="dropdown" aria-expanded="true">
              <i class="md md-notifications"></i>
              <span class="badge badge-xs badge-pink">2</span>
            </a>
            <ul class="dropdown-menu dropdown-menu-lg">
              <li class="text-center notifi-title">Notification</li>
              <li class="list-group nicescroll notification-list">
                <!-- list item-->
                <a [routerLink]="['/underconstruction']" class="list-group-item">
                  <div class="media">
                    <div class="pull-left p-r-10">
                      <em class="md md-textsms noti-primary"></em>
                    </div>
                    <div class="media-body">
                      <h5 class="media-heading">You have received a new SMS</h5>
                      <p class="m-0">
                        <small>From James Faulkner</small>
                      </p>
                    </div>
                  </div>
                </a>
                <!-- list item-->
                <a [routerLink]="['/underconstruction']" class="list-group-item">
                  <div class="media">
                    <div class="pull-left p-r-10">
                      <em class="md md-warning noti-danger"></em>
                    </div>
                    <div class="media-body">
                      <h5 class="media-heading">Respondent Cancellation</h5>
                      <p class="m-0">
                        <small>New cancellation for Job No 123-17</small>
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </li>
          <li class="dropdown" (click)="isShowMobileMenu = false">
            <span class="top-menu-user-txt hidden-xs pull-left">{{loginusername}}</span>
            <!-- <a tabindex="0" class="dropdown-toggle waves-effect waves-light profile" data-toggle="dropdown"
              aria-expanded="true" type="button">
              <i class="md md-person"></i>
            </a> -->
            <a tabindex="0" class="dropdown-toggle waves-effect waves-light profile" data-toggle="dropdown" #menutoggle
              (keydown.enter)="menutoggle.click()" (keydown.tab)="menutoggle.click()">
              <i class="md md-person" title="User"></i>
            </a>
            <ul class="dropdown-menu">
              <li>
                <a href="javascript:void(0)" [routerLink]="['/settings']"><i class="ti-settings m-r-5"></i> My
                  Settings</a>
              </li>
              <li>
                <a [routerLink]="['/rescontactus']">
                  <i class="ti-email m-r-5"></i> Contact Us</a>
              </li>
              <li><a href="javascript:;" (click)="logOut()"><i class="ti-power-off m-r-5"></i> Logout</a></li>
            </ul>
          </li>
        </ul>
        <div class="menu-item">
          <!-- Mobile menu toggle-->
          <a class="navbar-toggle" (click)="isShowMobileMenu = !isShowMobileMenu">
            <div class="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>
          <!-- End mobile menu toggle-->
        </div>
      </div>
    </div>
  </div>
  <!-- End topbar -->
  <!-- Navbar Start -->
  <div class="navbar-custom">
    <div class="container">
      <div id="navigation" [class.mobile-menu-show]="isShowMobileMenu">
        <!-- Navigation Menu-->
        <ul class="navigation-menu">
          <li class="has-submenu" (click)="isShowMobileMenu = false">
            <a [routerLink]="['/reshome']">
              <i class="">
                <img src="assets/icons/respontent/house.svg" style="height: 30px; width: 30px;" alt="">
              </i>Home
            </a>
          </li>

          <li class="has-submenu" (click)="isShowMobileMenu = false">
            <a [routerLink]="['/resprofile']">
              <i class="">
                <img src="assets/icons/respontent/browser.svg" style="height: 30px; width: 30px;" alt="">
              </i>My Profile
            </a>
          </li>

          <li tabindex="0" class="has-submenu">
            <a tabindex="-1" href="javascript:;">
              <i class="">
                <img src="assets/icons/respontent/money.svg" style="height: 30px; width: 30px;" alt="">
              </i>My Accounts
            </a>
            <ul class="submenu" (click)="isShowMobileMenu = false">
              <!-- <li><a [routerLink]="['/searchrespondents']">Search Panel Member</a></li> -->
              <li>
                <a [routerLink]="['/resbanking']">My Bank Details</a>
              </li>
              <li *ngIf="isPointsAllowed">
                <a [routerLink]="['/respoints']">My Points</a>
              </li>
              <li>
                <a [routerLink]="['/respayments', loginuserid]">My Payments</a>
              </li>
            </ul>
          </li>

          <li class="has-submenu" (click)="isShowMobileMenu = false">
            <a [routerLink]="['/ressurvey', loginuserid]">
              <i class="">
                <img src="assets/icons/respontent/file.svg" style="height: 30px; width: 30px;" alt="">
              </i>My Surveys
            </a>
          </li>

          <li class="has-submenu" (click)="isShowMobileMenu = false">
            <a [routerLink]="['/ressession', loginuserid]">
              <i class="">
                <img src="assets/icons/respontent/calendar.svg" style="height: 30px; width: 30px;" alt="">
              </i>My Sessions
            </a>
          </li>

          <!-- <li class="has-submenu" (click)="isShowMobileMenu = false">
            <a [routerLink]="['/resopportunities', loginuserid]">
              <i class="">
                <img src="assets/icons/jobs-files.svg" style="height: 30px; width: 30px;">
              </i>My Opportunities
            </a>
          </li> -->

          <!-- <li *ngIf="isFarronResearch" class="has-submenu" (click)="isShowMobileMenu = false">
            <a [routerLink]="['/ressocialshare']">
              <i class="">
                <img src="assets/icons/3-user1.svg" style="height: 30px; width: 30px;" alt="">
              </i>Share With Friends
            </a>
          </li> -->
        </ul>
        <!-- End navigation menu -->
      </div>
      <!-- end #navigation -->
    </div>
    <!-- end container -->
  </div>
  <!-- end navbar-custom -->
</header>
<!-- End Navigation Bar-->